exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-59ea88c2]{background:#f7f7f7;font-size:.28rem;color:#19191a;width:86%;height:7.506rem;margin-left:3%;padding:0 4%}.container .title[data-v-59ea88c2]{text-align:center;margin-bottom:.32rem;padding-top:.65rem}.container ul li[data-v-59ea88c2]:first-child{width:25%;text-align:left;float:left}.container ul li[data-v-59ea88c2]:last-child{width:75%;text-align:left;float:left}.container li[data-v-59ea88c2]{display:inline-block}.container ul[data-v-59ea88c2]{line-height:.44rem}.container ul[data-v-59ea88c2]:after{content:\"\";display:block;clear:both}.container .tips[data-v-59ea88c2]{font-size:.28rem;color:#ff5548}.QRcode[data-v-59ea88c2]{width:100%;text-align:center}.QRcode p[data-v-59ea88c2]{font-size:.24rem;color:#19191a;padding-bottom:.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59ea88c2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/pass-status/components/Pass.vue
// module id = TfzY
// module chunks = 1